<template>
  <widget
    :color="color"
    icon="fas fa-concierge-bell"
    title="Success inbound chats"
    :percent="percent"
    :value="value"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget9'

export default {
  components: {
    Widget
  },
  props: {
    refresh: Boolean,
    direction: String
  },
  data() {
    return {
      color: this.$getChatColor[0],
      percent: 0,
      value: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getServiceSuccess()
      }
    }
  },
  methods: {
    async getServiceSuccess() {
      try {
        const success = await apiRealtime.getChatSessionSuccess({
          direction: this.direction
        })

        this.value = success.total
        this.percent = success.percent

        this.$emit('reset', 'chatSessionSuccess')
      } catch (error) {}
    }
  }
}
</script>
